import { Vehicle } from "../Interfaces/vehicle.type";
import Delivery from "./Delivery";
import Collection from "./Collection";
import Offsite from "./NoTransport";

interface TransportProps {
  vehicle: Vehicle;
  degradedServices: string[];
}

const Transport: React.FunctionComponent<TransportProps> = ({
  vehicle,
  degradedServices,
}) => {
  const isPartnerFinance =
    vehicle.paymentStatus === "PartnerFinanceInvoice" ||
    vehicle.paymentStatus === "PartnerFinanceFailed" ||
    vehicle.paymentStatus === "PartnerFinanceProcessing";
  const hasDeliveryBooked = Boolean(vehicle.orderState);
  const hasCollectionBooked = vehicle.isBookedForCollection === true;
  const invoicePaid = vehicle.paymentStatus === "InvoicePaid";
  const isVehicleOffsited = vehicle.isVehicleOffsited;

  const invoiceServiceDegraded = degradedServices?.includes("InvoiceService");
  const deliveryServiceDegraded = degradedServices?.includes("DeliveryService");
  const openBankingServiceDegraded =
    degradedServices?.includes("OpenBankingService");

  const shouldDisplayDelivery =
    !isPartnerFinance &&
    hasDeliveryBooked &&
    !deliveryServiceDegraded &&
    !invoiceServiceDegraded &&
    !openBankingServiceDegraded;
  const shouldDisplayCollection = !isPartnerFinance && hasCollectionBooked;
  const shouldDisplayOffsite =
    (invoicePaid || vehicle.paymentStatus === "PartnerFinanceInvoice") &&
    !hasDeliveryBooked &&
    !hasCollectionBooked &&
    isVehicleOffsited;

  const getTransportStatus = () => {
    if (shouldDisplayCollection) {
      return (
        <Collection vehicle={vehicle} degradedServices={degradedServices} />
      );
    } else if (shouldDisplayDelivery) {
      return <Delivery vehicle={vehicle} degradedServices={degradedServices} />;
    } else if (shouldDisplayOffsite) {
      return <Offsite />;
    } else {
      return null;
    }
  };

  return getTransportStatus();
};

export default Transport;
